var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "user-heatmap" } },
    [
      _c("div", { staticClass: "total-contributions" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.values.length) +
            " contributions in the last 12 months\n  "
        )
      ]),
      _vm._v(" "),
      _c("calendar-heatmap", {
        attrs: {
          locale: _vm.locale,
          "no-data-text": _vm.locale.no_contributions,
          "tooltip-unit": _vm.locale.contributions,
          "end-date": _vm.endDate,
          values: _vm.values,
          "range-color": _vm.colorRange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }